import Header from "../components/landing/Header";
import Pricing from "../components/landing/Pricing";
import CTASection from "../components/landing/CTASection";
import Footer from "../components/landing/Footer";

export default function PricingPage() {
  return (
    <main data-testid="pricing-page" className="relative">
      <Header />
      <div className="pt-24">
        <Pricing />
      </div>
      <CTASection />
      <Footer />
    </main>
  );
}
